import { useEffect, useState } from "react";

// Soft site gate — keeps casual visitors out while the site is being finished.
// Note: this is a client-side gate (preview/protection), not real security.
const KEY = "imaginary_gate";
// SHA-256 of the gate password — the raw password never sits in the repo.
const PASSWORD_HASH = "d8b78d1814c8a8d0430d3e26345650f1dd5b5a04243da9d2403192407432d165";

async function sha256(text) {
  const buf = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(text));
  return Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, "0")).join("");
}

export default function SiteGate({ children }) {
  const [unlocked, setUnlocked] = useState(false);
  const [checking, setChecking] = useState(true);
  const [pwd, setPwd] = useState("");
  const [error, setError] = useState(false);

  useEffect(() => {
    try {
      if (localStorage.getItem(KEY) === PASSWORD_HASH) setUnlocked(true);
    } catch {}
    setChecking(false);
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    const h = await sha256(pwd);
    if (h === PASSWORD_HASH) {
      try {
        localStorage.setItem(KEY, h);
      } catch {}
      setUnlocked(true);
    } else {
      setError(true);
      setPwd("");
    }
  };

  if (checking) return null;
  if (unlocked) return children;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-[#faf8f5] px-6"
      data-testid="site-gate"
    >
      <div className="w-full max-w-sm text-center">
        <p className="font-display text-6xl tracking-tight text-[#111111] italic">X</p>
        <p className="mt-6 font-display text-xl tracking-tight text-[#111111]">
          Imaginary <span className="italic">Collection</span>
        </p>
        <p className="mt-3 text-xs uppercase tracking-[0.3em] text-[#a89f8e]">
          Ouverture prochaine — Opening soon
        </p>
        <form onSubmit={submit} className="mt-10" data-testid="gate-form">
          <input
            type="password"
            value={pwd}
            onChange={(e) => { setPwd(e.target.value); setError(false); }}
            placeholder="Mot de passe — Password"
            autoFocus
            data-testid="gate-password"
            className={`w-full border bg-white px-4 py-3.5 text-center text-sm font-light outline-none transition-colors ${
              error ? "border-[#c2402a]" : "border-[#111111]/25 focus:border-[#111111]"
            }`}
          />
          {error && (
            <p className="mt-2 text-xs font-light text-[#c2402a]" data-testid="gate-error">
              Mot de passe incorrect — Wrong password
            </p>
          )}
          <button
            type="submit"
            data-testid="gate-submit"
            className="mt-4 w-full bg-[#111111] px-7 py-3.5 text-sm font-light tracking-wide text-[#faf8f5] transition-opacity duration-300 hover:opacity-85"
          >
            Entrer — Enter
          </button>
        </form>
      </div>
    </div>
  );
}
